import { fetch } from '../utils/request';
import { GRAPHICS_BASE } from './services';

const getUrl = (path) => `${GRAPHICS_BASE}${path}`;

export default {
  /**
   * Get a single graphic template by ID.
   * @param {string} templateId - The ID of the graphic template to fetch.
   * @returns {Promise<Object>} - A promise that resolves to the response from the API.
   */
  getTemplate(templateId) {
    return fetch(getUrl(`/template/${templateId}`));
  },

  /**
   * Fetch multiple graphic templates from API by IDs.
   * @param {string} userId - The ID of the owner of the graphic templates.
   * @param {Array<string>} templateIds - An array of template IDs.
   * @returns {Promise<Array<Object>>} - A promise that resolves to the response from the API.
   */
  getMultiple(userId, templateIds = []) {
    return fetch(getUrl(`/templates/${userId}/many?templates=${templateIds.join(',')}`));
  },

  /**
   * Get a saved graphic by ID (created via Producer).
   * @param {string} graphicId - The ID of the graphic to fetch.
   * @returns {Promise<Object>} - A promise that resolves to the response from the API.
   */
  getGraphic(graphicId) {
    return fetch(getUrl(`/graphic/${graphicId}`));
  },
};
